'use strict'

import { z } from 'zod/mini'

/** IF02098 API レスポンスの更新状況オブジェクト（snake_case） */
const UpdateStatusApiSchema = z.looseObject({
  total: z.optional(z.number()),
  updated: z.optional(z.number()),
  update_pending: z.optional(z.number()),
  reupdate_pending: z.optional(z.number()),
  verification_pending: z.optional(z.number()),
  verifying: z.optional(z.number()),
  error: z.optional(z.number()),
  configuring: z.optional(z.number()),
  unset: z.optional(z.number())
})

/** IF02098 API タスク1件（snake_case） */
const TaskApiSchema = z.looseObject({
  key: z.union([z.number(), z.string()]),
  period_kind: z.string(),
  period_value: z.string(),
  display_status: z.string(),
  message: z.optional(z.string()),
  personnel_update_status: z.optional(UpdateStatusApiSchema),
  accounting_update_status: z.optional(UpdateStatusApiSchema)
})

/** IF02098 API 決算期グループ（snake_case） */
const FiscalPeriodGroupApiSchema = z.looseObject({
  fiscal_period: z.string(),
  tasks: z.optional(z.array(TaskApiSchema))
})

/** IF02098 GET get_data_update_task_info ボディ（snake_case） */
export const DataUpdateTaskInfoApiBodySchema = z.looseObject({
  fiscal_period_options: z.optional(z.array(z.string())),
  fiscal_period_groups: z.optional(z.array(FiscalPeriodGroupApiSchema))
})
